
import React from "react";
import { get } from "lodash";
import { AMORTIZATION_TYPES, LOAN_RATE_TYPES } from "@loanbossinc/component-library";
import { Grid } from "@material-ui/core";

import {
  StyledGridContainer, StyledLinkContainer, StyledLinkContainerRight, StyledFormikInputNumber, StyledFormikInputMoney, StyledFormikInputPercent, StyledFormikInputTypeAhead,
  StyledLinkText, StyledLinkTextFloatRight, StyledPrepaymentScheduleContainer, StyledPrepaymentScheduleContainerFooter, Divider, StyledRowHeader, StyledRowSubHeader, StyledFormikInputText
} from "./section.styles";

export const addExtensionRow = (values, setValues) => {
  const extensions = values.extensions;
  extensions.push({});
  setValues({
    ...values,
    extensions
  });
};

const special = ["Zeroth",
  "First",
  "Second",
  "Third",
  "Fourth",
  "Fifth",
  "Sixth",
  "Seventh",
  "Eighth",
  "Ninth",
  "Tenth",
  "Eleventh",
  "Twelfth",
  "Thirteenth",
  "Fourteenth",
  "Fifteenth",
  "Sixteenth",
  "Seventeenth",
  "Eighteenth",
  "Nineteenth"];
const deca = ["Twent", "Thirt", "Fort", "Fift", "Sixt", "Sevent", "Eight", "Ninet"];
const getRowHeader = n => {
  if (n < 20) {
    return `${special[n]} Extension`;
  }
  if (n % 10 === 0) {
    return `${deca[Math.floor(n / 10) - 2]}ieth` + " Extension";
  }

  return `${deca[Math.floor(n / 10) - 2]}y-${special[n % 10]} Extension`;
};

export const getRow = (index, values, setValues) => (<>
  <StyledPrepaymentScheduleContainer container>
    <StyledGridContainer item xs={12}>
      <StyledRowHeader>{getRowHeader(index + 1)}</StyledRowHeader>
    </StyledGridContainer>
    <StyledGridContainer item xs={12}>
      <StyledFormikInputNumber
        name={`extensions[${index}].extensionTerm`}
        label={"Extension Term (months)"}
        variant={"filled"}
      />
    </StyledGridContainer>
    <Divider />
    {values.extensions[index].isVisible && renderExtensionDetails(index, values, setValues)}
  </StyledPrepaymentScheduleContainer>

  {getFooter(values, index, setValues)}
</>
);

const renderExtensionDetails = (index, values, setValues) => {
  const amortizationTypes = values && values.ancillary && values.ancillary.amortizationTypes ? values.ancillary.amortizationTypes : [];
  const amortizationTypeId = get(values, `extensions[${index}].extensionAmortizationTypeId`);
  const rateTypeId = get(values, "details.rateTypeId");
  const showMonthlyPrincipalReduction = amortizationTypeId === AMORTIZATION_TYPES.STRAIGHT_LINE_CUSTOM_AMORT;
  const showAmortizationRate = amortizationTypeId === AMORTIZATION_TYPES.MORTGAGE_STYLE && rateTypeId === LOAN_RATE_TYPES.FLOATING;
  const hideAmortTerm = amortizationTypeId && amortizationTypeId === AMORTIZATION_TYPES.INTEREST_ONLY;

  return (
    <>
      <StyledGridContainer container item xs={12}>
        <Grid item xs={5}>
          <StyledFormikInputNumber
            name={`extensions[${index}].extensionNoticeMin`}
            label={"Notice Due Min (days)"}
            variant={"filled"}
          />
        </Grid>
        <Grid item xs={2} />
        <Grid item xs={5}>
          <StyledFormikInputNumber
            name={`extensions[${index}].extensionNoticeMax`}
            label={"Notice Due Max (days)"}
            variant={"filled"}
          />
        </Grid>
      </StyledGridContainer>
      <Divider />

      <StyledGridContainer container item xs={12}><StyledRowSubHeader>Minimum Qualifications</StyledRowSubHeader></StyledGridContainer>
      <StyledGridContainer container item xs={12}>
        <Grid item xs={3}>
          <StyledFormikInputPercent
            name={`extensions[${index}].extensionLtv`}
            label={"LTV (%)"}
            decimals={3}
            variant={"filled"}
          />
        </Grid>
        <Grid item xs={1} />
        <Grid item xs={3}>
          <StyledFormikInputNumber
            name={`extensions[${index}].extensionDscr`}
            label={"DSCR"}
            decimals={2}
            variant={"filled"}
          />
        </Grid>
        <Grid item xs={1} />
        <Grid item xs={3}>
          <StyledFormikInputPercent
            name={`extensions[${index}].extensionDebtYield`}
            label={"Debt Yield (%)"}
            decimals={3}
            variant={"filled"}
          />
        </Grid>
      </StyledGridContainer>
      <Divider />

      <StyledGridContainer container item xs={12}><StyledRowSubHeader>Amortization</StyledRowSubHeader></StyledGridContainer>
      <StyledGridContainer item xs={12}>
        <StyledFormikInputTypeAhead
          id="extensionAmortizationTypeId"
          name={`extensions[${index}].extensionAmortizationTypeId`}
          label="Amortization Type"
          options={amortizationTypes}
          displayWith={option => option && option.name}
          setValueWith={option => option && option.id}
          onChange={value => { }}
          className="input"
          variant={"filled"}
        />
      </StyledGridContainer>

      {!hideAmortTerm && <StyledGridContainer container item xs={12}>
        <StyledFormikInputNumber
          name={`extensions[${index}].extensionAmortizationTerm`}
          label={"Amortization Term (months)"}
          variant={"filled"}
        />
                         </StyledGridContainer>}
      {showMonthlyPrincipalReduction && <StyledGridContainer container item xs={12}>
        <StyledFormikInputMoney
          name={`extensions[${index}].extensionAmortizationPrincipalReduction`}
          label={"Principal Reduction ($)"}
          variant={"filled"}
        />
                                        </StyledGridContainer>}

      {showAmortizationRate && <StyledGridContainer container item xs={12}>
        <StyledFormikInputPercent
          name={`extensions[${index}].extensionAmortizationRate`}
          label={"Rate (%)"}
          decimals={3}
          variant={"filled"}
        />
                               </StyledGridContainer>}
      <Divider />

      <StyledGridContainer container item xs={12}><StyledRowSubHeader>Fees</StyledRowSubHeader></StyledGridContainer>

      <StyledGridContainer container item xs={12}>
        <StyledFormikInputPercent
          name={`extensions[${index}].extensionFee`}
          label={"Extension Fee (%)"}
          decimals={3}
          variant={"filled"}
        />
      </StyledGridContainer>

      <StyledGridContainer container item xs={12}>
        <StyledFormikInputText
          name={`extensions[${index}].extensionQualifications`}
          label={"Qualifications"}
          variant={"filled"}
        />
      </StyledGridContainer>

      <Divider />

      <StyledGridContainer container item xs={12}><StyledRowSubHeader>Miscellaneous</StyledRowSubHeader></StyledGridContainer>

      <StyledGridContainer container item xs={12}>
        <StyledFormikInputText
          name={`extensions[${index}].extensionMisc`}
          label={"Miscellaneous"}
          variant={"filled"}
        />
      </StyledGridContainer>
    </>
  );
};

export const getFooter = (values, index, setValues) => {
  const isVisible = values.extensions[index].isVisible;

  return (<StyledPrepaymentScheduleContainerFooter container>
    <StyledLinkContainer item xs={5}>
      <StyledLinkText
        onClick={() => {
          openCloseDetails(values, index, setValues);
        }}
      >
        {`${isVisible ? "Hide" : "Show"} extension details`}
      </StyledLinkText>
    </StyledLinkContainer>
    <StyledLinkContainerRight item xs={5}>
      <StyledLinkTextFloatRight
        onClick={() => {
          deleteExtension(values, index, setValues);
        }}
      >
        Delete extension
      </StyledLinkTextFloatRight>
    </StyledLinkContainerRight>
          </StyledPrepaymentScheduleContainerFooter>);
};
export const openCloseDetails = (values, index, setValues) => {
  const extensions = values.extensions;
  extensions[index].isVisible = !extensions[index].isVisible;
  setValues({
    ...values,
    extensions
  });
};
export const deleteExtension = (values, index, setValues) => {
  const extensions = values.extensions;
  extensions.splice(index, 1);
  setValues({
    ...values,
    extensions
  });
};
export const renderExtensions = (values, setValues) => {
  if (!values || !values.extensions || values.extensions.length === 0) {
    return null;
  }

  return values.extensions.map((item, index) => getRow(index, values, setValues));
};
